module.exports = __webpack_public_path__ + "img/naughty_olive.80a4aedc.png";